// Styles
import '../scss/main.scss';

// Scripts
import { offer } from '@shop/frontend/dist/desktop/order-full-form';
import './custom/social-proof.js';

jQuery(function () {
  offer.getState(function (data) {
    const cmp = data.query.cmp;
    if (cmp === 'false') {
      $('.cmp-show').show();
    }

    const currency = offer.getCurrency();
    const products = offer.getProducts();
    const productClass = '.product';

    for (let i = 0; i < products.length; i++) {
      $(productClass + (i + 1) + ' .save').html(currency + products[i].templates.save.split('.')[0]);
      $(productClass + (i + 1) + ' .pricee').html(currency + products[i].price);
    }
  });

  $('select')
    .on('change', function () {
      const $select = $(this);
      if ($select.val() == '') {
        $select.css('color', '#676873');
      } else {
        $select.css('color', '#1c1c28');
      }
    })
    .change();
});
